// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"VideoPlayer_wrapper__BI9xf","fullScreen":"VideoPlayer_fullScreen__zOvT0","loading":"VideoPlayer_loading__KjViK","roundCorners":"VideoPlayer_roundCorners__vLjrx"};